import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Home, Rocket } from 'lucide-react';

export const PoPCompactNav = ({ user, activeTab, academyUrl }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  const items = [
    ['ai-mba', '/pop/ai-mba', 'AI-Enabled MBA'], ['directory', '/pop/directory', 'Directory'],
    ['opps', '/pop/opportunities', 'Opportunities'], ['books', '/pop/books', 'Books'],
    ['events', '/pop/events', 'Events'], ['library', '/pop/library', 'Library'],
    ['questions', '/pop/questions', 'Q&A'],
    ...(user && ['faculty', 'university', 'industry_expert', 'super_admin'].includes(user.role) ? [['gaps', '/pop/gaps', 'Gaps']] : []),
    ...(user && ['student', 'faculty', 'industry_expert'].includes(user.role) ? [['learning', '/pop/learning', 'Learning']] : []),
    ...(user ? [['messages', '/pop/messages', 'Messages']] : []),
    ...(user && user.role !== 'unassigned' ? [['dashboard', '/pop/dashboard', 'Dashboard']] : []),
    ...(user?.role === 'super_admin' ? [['admin', '/pop/admin', 'Admin']] : []),
  ];
  return <nav aria-label="Professor of Practice navigation" className="xl:hidden border-t border-white/10 px-4 sm:px-6 py-2" data-testid="pop-compact-nav">
    <div className="flex flex-wrap items-center gap-2">
      <Link to="/pop" data-testid="pop-compact-home" className="inline-flex items-center gap-1 px-2 py-2 text-xs text-white/75 hover:text-white"><Home size={13} />Home</Link>
      <Link to="/pop/capstone" data-testid="pop-compact-capstone" aria-current={activeTab === 'capstone' ? 'page' : undefined}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-semibold bg-amber-300/10 text-amber-200 border border-amber-300/30 hover:bg-amber-300/20">
        <Rocket size={14} />Capstone Studio
      </Link>
      <button type="button" data-testid="pop-compact-menu-toggle" aria-expanded={open} aria-controls="pop-compact-menu"
        onClick={() => setOpen(value => !value)} className="inline-flex items-center gap-1 px-2 py-2 text-xs text-white/75 hover:text-white">
        More<ChevronDown size={13} />
      </button>
    </div>
    {open && <div id="pop-compact-menu" data-testid="pop-compact-menu" className="grid grid-cols-2 gap-1 mt-2 max-h-[55dvh] overflow-y-auto border-t border-white/10 pt-2">
      {items.map(([id, to, label]) => <Link key={id} to={to} data-testid={`pop-compact-${id}`} aria-current={activeTab === id ? 'page' : undefined}
        className={`px-3 py-2 rounded text-xs break-words hover:bg-white/5 ${activeTab === id ? 'text-amber-200 bg-amber-300/10' : 'text-white/80'}`}>{label}</Link>)}
      <a href={academyUrl} target="_blank" rel="noopener noreferrer"
        data-testid="pop-compact-academy" className="px-3 py-2 text-xs text-white/80 hover:bg-white/5 rounded">Soft Skills</a>
      <Link to="/" data-testid="pop-compact-samanvai" className="px-3 py-2 text-xs text-white/70 hover:text-white">Back to SAMANVAI</Link>
    </div>}
  </nav>;
};